import { render, staticRenderFns } from "./ModalBuscarCliente.vue?vue&type=template&id=cdbe2f3c&"
import script from "./ModalBuscarCliente.vue?vue&type=script&lang=js&"
export * from "./ModalBuscarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports